export const trivia = {
  title: "Magnum, P.I. Trivia",
  questions:
  [
    {
      q: "What is Magnum's middle name?",
      a: ["Sullivan", "Thomas", "Stone"],
    },
    {
      q: "What brand of car did Magnum usually drive?",
      a: ["Ferrari", "Aston Martin", "Jaguar"],
      followup: "To be specific, it was a Ferrari 308 GTS.",
    },
    {
      q: "What are the names of Higgins' dogs?",
      a: ["Zeus and Apollo", "Jupiter and Mars", "Hercules and Achilles"],
    },
    {
      q: "How many seasons of Magnum P.I. are there?",
      a: [8, 7, 9],
      followup: "There were only 13 episodes in the 8th season.",
    },
    {
      q: "In what year did Tom Selleck win an Emmy for Magnum?",
      a: ["1984", "1983", "1985"],
      followup:
        "John Hillerman also won an Emmy years later for his portrayal of Higgins.",
    },
    {
      q: "What was the name of TC's helicopter business?",
      a: ["Island Hoppers", "Hawaiian Touring", "Island Tours"],
    },
    {
      q: "What does TC stand for?",
      a: ["Theodore Calvin", "Thomas Crane", "Timothy Calvin"],
    },
    {
      q: "What is the nickname of Rick's crime boss father figure?",
      a: ["Icepick", "Iceman", "Ibold"],
      followup: "His real name is Francis Hofstetler.",
    },
    {
      q: "What was the name of Magnum's wife?",
      a: ["Michelle", "Marilyn", "Maggie"],
    },
    {
      q: "What is the name of Magnum's daughter?",
      a: ["Lily", "Rose", "April"],
      followup: "Magnum didn't know he had a daughter until she was five.",
    },
    {
      q: "Which branch of the military did Magnum serve in?",
      a: ["Navy", "Army", "Marines"],
    },
    {
      q: "What is Magnum's favorite baseball team?",
      a: ["Detroit Tigers", "New York Yankees", "Boston Red Sox "],
    },
    {
      q: "Who's estate does Higgins manage?",
      a: ["Robin Masters", "Robert Ludlum", "Robin MacDonald"],
    },
    {
      q: "What is the estate's nickname where Magnum lives?",
      a: ["Robin's Nest", "Paradise", "Robin's Refuge"],
    },
    {
      q: 'In the pilot episode, Rick owned a club called "Rick\'s Place".',
      a: [true, false],
      followup:
        "Rick's character was originally patterned after Humphrey Bogart's character in Casablanca.",
    },
    {
      q: "What is Higgins' middle name?",
      a: ["Quayle", "Quigley", "Jonathan"],
      followup: "His full name was Jonathan Quayle Higgins III.",
    },
    {
      q: "Frank Sinatra guest-starred in Season 7.",
      a: [true, false],
    },
    {
      q: "Rick managed the King Kahakai club.",
      a: [false, true],
      followup: "Rick managed the King Kamehameha Club.",
    },
    {
      q: "Magnum could be found drinking which beers?",
      a: [
        "Old Dusseldorf and Coops",
        "Coors and Old Style",
        "Old Dusseldorf and Miller Genuine Draft",
      ],
    },
    {
      q: "Which actor portrayed TC on the show?",
      a: ["Roger E. Mosley", "Larry Manetti", "Roger Stone"],
    },
    {
      q: "Which actor portrayed Rick on the show?",
      a: ["Larry Manetti", "Roger E. Mosley", "Jeff Mackay"],
    },
    {
      q: "Carol Burnett guest starred on the show twice.",
      a: [true, false],
      followup: "Carol Burnett appeared in Seasons 4 and 8.",
    },
    {
      q: "Magnum P.I. aired on which network?",
      a: ["CBS", "NBC", "ABC"],
    },
    {
      q: "What is Rick's given first name?",
      a: ["Orville", "Richard", "Orson"],
    },
    {
      q: "Who primarily voiced Robin Masters in the show?",
      a: ["Orson Welles", "John Hillerman", "Gregory Peck"],
    },
    {
      q: "Magnum appeared in an episode of 'Murder, She Wrote'.",
      a: [true, false],
      followup: "Angela Lansbury also appeared in an episode of Magnum P.I..",
    },
    {
      q: "What rank did Higgins earn in the British Army?",
      a: ["Sergeant Major", "Lieutenant", "Corporal"],
    },
    {
      q: "Magnum served in which war?",
      a: ["Vietnam", "Korean War", "Cold War"],
      followup:
        "Magnum P.I. was one of the first shows to include positive portrayals of Vietnam veterans.",
    },
    {
      q:
        "Which assistant district attorney frequently worked with Magnum?",
      a: ["Carol Baldwin", "Maggie Poole", "Luther Gillis"],
    },
    {
      q: "Which of the following are bartenders mentioned in the show?",
      a: ["Moki and Keoki", "Yoshi and Keoki", "Mac and Buck"],
    },
    {
      q: "Tom Selleck appeared in all 162 episodes of Magnum",
      a: [true, false],
    },
    {
      q:
        "What movie did Tom Selleck famously turn down because of his Magnum contract?",
      a: ["Indiana Jones", "Blade Runner", "The Shining"],
      followup:
        'This casting was spoofed in a Season 8 episode entitled, "Legend of the Lost Art".',
    },
    {
      q: "What brand of gun did Magnum carry?",
      a: ["Colt", "Smith and Wesson", "Beretta"],
      followup: "Magnum carried a Colt 45 ACP.",
    },
    {
      q: "What breed of dog were Higgins' dogs?",
      a: ["Doberman", "Rottweiler", "Bulldog"],
    },
    {
      q:
        "What TV show reunited Tom Selleck, Larry Manetti, and Roger Mosley in the 2000s?",
      a: ["Las Vegas", "Friends", "Jesse Stone"],
    },
    {
      q: "How many episodes did Robin Masters speak in?",
      a: [6, 7, 8],
    },
    {
      q:
        "What is the name of the pattern of the Hawaiian shirt made famous by Magnum?",
      a: ["Jungle Bird", "Aloha Jungle", "Paradise Found"],
    },
    {
      q: "Which of these props was not donated to the Smithsonian?",
      a: ["Ferrari license plate", "Hawaiian shirt", "Detroit Tigers hat "],
      followup:
        "An Hawaiian shirt, baseball cap, and the team ring were donated in 2002.",
    },
    {
      q: "The team ring is what two colors?",
      a: ["Gold and Black", "Silver and Gold", "Black and Silver "],
    },
    {
      q: "How many of Higgins' half-brothers were seen on the show?",
      a: [3, 1, 2],
      followup: "Each was played by John Hillerman.",
    },
    {
      q: "What island is Robin Masters' estate located on?",
      a: ["Oahu", "Hawaii", "Maui"],
    },
    {
      q: "Which of these recurring characters was seen in more episodes?",
      a: ["Agatha Chumley", "Lieutenant Tanaka", "Doc Ibold"],
      followup: "Agatha Chumley can be seen in 32 episodes.",
    },
    {
      q:
        "Which of these minor recurring characters was seen in more episodes?",
      a: ["Icepick", "Buck Greene", "Maggie Poole"],
    },
    {
      q: "How many episodes does Magnum's mother appear in?",
      a: [5, 4, 3],
    },
    {
      q: "The series finale aired on what date?",
      a: ["May 8, 1988", "April 8, 1987", "May 1, 1989"],
    },
    {
      q: "In what state was Magnum raised in?",
      a: ["Virginia", "Michigan", "Ohio"],
    },
    {
      q: "What university did Magnum attend?",
      a: ["Naval Academy", "West Point", "Air Force Academy"],
    },
    {
      q:
        "The events in the Ironman Triathlon that Magnum competed in are out of order.",
      a: [true, false],
      followup: "The correct order is Swim, Bike, and then Run.",
    },
    {
      q: "What position did Magnum play on his college football team?",
      a: ["Quarterback", "Cornerback", "Wide Receiver"],
    },
    {
      q: "Magnum appeared on the show without a mustache.",
      a: [false, true],
    },
  ]
}
